<template>
  <div class="mt-5">
    <h1>Logging out....</h1>
  </div>
</template>

<script>
export default {
  data: () => ({
    username: "",
    password: "",
  }),
  mounted() {
    this.logout()
  },
  methods: {
    logout: async function() {
      // localStorage.setItem("user_token", "ini user token");
      await this.$store.dispatch("pmse/logout")
      await this.$store.dispatch("auth/logout").then(() => {
        window.location.replace(
          // "https://10.0.11.120/auth/realms/pegawai-bps/protocol/openid-connect/logout" +
          "https://sso.bps.go.id/auth/realms/pegawai-bps/protocol/openid-connect/logout" +
            "?&redirect_uri=" +
            // window.location.replace(
            //   "http://10.0.11.120/auth/realms/pegawai-bps/protocol/openid-connect/logout" +
            //     "?&redirect_uri=" +
            window.location.protocol +
            "//" +
            window.location.host +
            process.env.VUE_APP_PUBLIC_PATH +
            "/pmse"
        )
        this.$router.push({ name: "PMSE" })
      })
    },
  },
}
</script>
